export const requestTimeout = 30000;
export const requestBaseURL = "/api";
export const loginRoutePath = "/login";
export const defaultRoutePath = "/";

export const noAuthMeta = {
  keepAlive: false,
  isAuth: false
};
export const hadAuthMeta = {
  keepAlive: false,
  isAuth: true
};
